import React, { Component } from "react";
import SimpleDataTable from "../../../../modules/SimpleDataTable";
import { defaultTableChange } from "../../../../modules/custom/customTable";
import { getTableConfigKelebihan } from "../configs/config";
import SimpleTextArea from "../../../../modules/simpleTextArea";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import FlexView from "react-flexview";
import { fetchDataDDLItem } from "../service";

class KelebihanSODetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tableColumn: [],
      dataDDL: [],
      isSaved: false,
      pagination:{
          limit: 5,
          page: 1,
          totalData: 0
      }
    };
  }

  async componentDidMount() {
    const type = this.props.controls.stockOpnameType?.value?.value;
    const ddlResult = await fetchDataDDLItem(this.setState.bind(this), type);

    const formattedRows = (
      this.props.state.dataKelebihan.listDataTanpaQR || []
    ).map((r) => ({
      ...r,
      isSaved: r.isSaved ?? true,
      diffQty: Number(r.differenceQty ?? 0),
    }));
    // console.log(this.props.state.dataKelebihan.listDataTanpaQR);
    // console.log(formattedRows);

    this.props.onSetState((prev) => ({
      ...prev,
      dataKelebihan: {
        ...prev.dataKelebihan,
        listDataTanpaQR: formattedRows,
      },
    }));

    this.setState({
      ddlPart: ddlResult,
      ddlGift: ddlResult,
      ddlItems: ddlResult,
      tableColumn: getTableConfigKelebihan(
        type,
        ddlResult,
        this.handleRowChange,
        this.props.state.dataKelebihan,
        this.handleToggleSaveRow,
        this.handleDeleteRow,
        this.props.state.dataKekurangan.listDataTanpaQR
      ),
    });
  }

  async componentDidUpdate(prevProps) {
    const prevType = prevProps.controls?.stockOpnameType?.value?.value;
    const currentType = this.props.controls?.stockOpnameType?.value?.value;

    if (prevType !== currentType) {
      const ddlResult = await fetchDataDDLItem(
        this.setState.bind(this),
        currentType,
      );

      this.setState({
        ddlPart: ddlResult,
        ddlGift: ddlResult,
        ddlItems: ddlResult,
        tableColumn: getTableConfigKelebihan(
          currentType,
          ddlResult,
          this.handleRowChange,
          this.props.state.dataKelebihan,
          this.handleToggleSaveRow, 
          this.handleDeleteRow,
          this.props.state.dataKekurangan.listDataTanpaQR
        ),
      });
    }

    const prevK = prevProps.state?.dataKelebihan || {};
    const currK = this.props.state?.dataKelebihan || {};

    const prevErrors = prevK.errorsTanpaQR;
    const currErrors = currK.errorsTanpaQR;

    const prevList = prevK.listDataTanpaQR;
    const currList = currK.listDataTanpaQR;

    const errorsChanged = prevErrors !== currErrors;
    const listChanged = prevList !== currList;

    if (errorsChanged || listChanged) {
      this.setState((prevState) => ({
        tableColumn: getTableConfigKelebihan(
          currentType,
          prevState.ddlPart || [],
          this.handleRowChange,
          this.props.state.dataKelebihan,
          this.handleToggleSaveRow,
          this.handleDeleteRow,
          this.props.state.dataKekurangan.listDataTanpaQR
        ),
      }));
    }
  }

  handleValueChange = (name, value) => {
    this.props.onSetState((prevValue) => ({
      ...prevValue,
      dataKelebihan: {
        ...prevValue.dataKelebihan,
        [name]: value,
      },
    }));
  };

  handleAddRow = () => {
    const newRow = {
      item: {
        kodePart: "",
        partName: null,
        partCategory: { value: "" },
        categoryDTO: { value: "" },
        qty: 0,
        satuan: { value: "" },
        satuanDTO: { value: "" },
      },
      diffQty: 0,
      notes: "",
      isSaved: false,
    };

    // console.log("this.props.state.dataKelebihan : ", JSON.stringify(this.props.state.dataKelebihan,null,2));

    this.props.onSetState((prev) => ({
      ...prev,
      dataKelebihan: {
        ...prev.dataKelebihan,
        listDataTanpaQR: [...prev.dataKelebihan.listDataTanpaQR, newRow],
      },
    }));
  };

  handleToggleSaveRow = (rowIndex, field, value) => {
    this.props.onSetState((prev) => {
      const rows = [...prev.dataKelebihan.listDataTanpaQR];

      if (!rows[rowIndex]) return prev;

      rows[rowIndex] = {
        ...rows[rowIndex],
        [field]: value,
      };

      return {
        ...prev,
        dataKelebihan: {
          ...prev.dataKelebihan,
          listDataTanpaQR: rows,
        },
      };
    });
  };

  handleDeleteRow = (rowIndex) => {
    this.props.onSetState((prev) => {
      const rows = [...prev.dataKelebihan.listDataTanpaQR];

      if (!rows[rowIndex]) return prev;
      rows.splice(rowIndex, 1);

      return {
        ...prev,
        dataKelebihan: {
          ...prev.dataKelebihan,
          listDataTanpaQR: rows,
        },
      };
    });
  };

  handleRowChange = (rowIndex, field, value) => {
    this.props.onSetState((prev) => {
      const rows = [...prev.dataKelebihan.listDataTanpaQR];
      const row = { ...rows[rowIndex], item: { ...rows[rowIndex].item } };
      // console.log(row);

      if (field === "partName") {
        if (!value) {
          row.item.kodePart = "";
          row.item.partName = "";
          row.item.partCategory = { value: "" };
          row.item.qty = "";
          row.item.satuan = { value: "" };
        } else {
          const selected = this.state.ddlPart.find(
            (x) => x.value === value.value,
          );
  
          row.item.kodePart = selected?.value || "";
          row.item.partName = selected?.label || "";
          row.item.partCategory = { value: selected?.partCategory?.value || "" };
          row.item.qty = selected?.qty || 0;
          row.item.satuan = { value: selected?.satuan?.value || "" };
        }
      } else {
        row[field] = value;
      }

      if (field === "nameHadiah") {
        if (!value) {
          row.item.kodeHadiah = "";
          row.item.nameHadiah = "";
          row.item.categoryHadiah = "";
          row.item.qrHadiah = "";
          row.item.satuanHadiah = "";
          row.item.status = "";
        } else {
          const selected = this.state.ddlGift.find(
            (x) => x.value === value.value,
          );
        
          row.item.kodeHadiah = selected?.value || "";
          row.item.nameHadiah = selected?.label || "";
          row.item.categoryHadiah = selected?.categoryHadiah || "";
          row.item.qrHadiah = selected?.qrHadiah || "";
          row.item.satuanHadiah = selected?.satuanHadiah || "";
          row.item.status = selected?.status || "";
        }
      } else {
        row[field] = value;
      }

      if (field === "nameotheritem") {
        if (!value) {
          row.item.kodeotheritem = "";
          row.item.nameotheritem = "";
          row.item.categoryDTO = { value: "" };
          row.item.qrotheritem = "";
          row.item.satuanDTO = { value: "" };
          row.item.status = "";
        } else {
          const selected = this.state.ddlItems.find(
            (x) => x.value === value.value,
          );
        
          row.item.kodeotheritem = selected?.value || "";
          row.item.nameotheritem = selected?.label || "";
          row.item.categoryDTO = { value: selected?.categoryDTO || "" };
          row.item.qrotheritem = selected?.qrotheritem || "";
          row.item.satuanDTO = { value: selected?.satuanDTO || "" };
          row.item.status = selected?.status || "";
        }
      } else {
        row[field] = value;
      }

      rows[rowIndex] = row;

      return {
        ...prev,
        dataKelebihan: {
          ...prev.dataKelebihan,
          listDataTanpaQR: rows,
        },
      };
    });
  };

  handleChangePage = (tableState) => {
      this.setState((prevValue) => ({
          ...prevValue,
          pagination:{
              ...prevValue.pagination,
              page: tableState.page + 1,
          }
      }));
  };

  handleRowsPerPage = (tableState) => {
      this.setState((prevValue) => ({
          ...prevValue,
          pagination:{
              ...prevValue.pagination,
              page: 1,
              limit: tableState.rowsPerPage,
          }
      }));
  };

  render() {
    return (
      <>
        {this.props.tab === "with_qr" && (
          <SimpleTextArea
            name="listDataQR"
            value={this.props.state.dataKelebihan.listDataQR}
            readOnly={
              this.props.edit ||
              this.props.selectedData.stockOpnameStatus == "COMPLETED"
            }
            onChange={({ target }) =>
              this.handleValueChange(target.name, target.value)
            }
          />
        )}
        {this.props.tab === "without_qr" && (
          <SimpleDataTable
            key={`${this.props.state.dataKelebihan.listDataTanpaQR?.length}-${this.state.pagination.page}`}
            data={this.props.state.dataKelebihan.listDataTanpaQR}
            columns={this.state.tableColumn}
            toCount={this.props.state.dataKelebihan.listDataTanpaQR.length}
            rowsPerPage={this.state.pagination.limit}
            page={this.state.pagination.page - 1}
            options={{...defaultTableChange(this.handleChangePage, this.handleRowsPerPage), serverSide: false}}
          />
        )}
        <FlexView style={{ justifyContent: "end", marginTop: "20px" }}>
          {this.props.tab === "without_qr" &&
            this.props.selectedData.stockOpnameStatus !== "COMPLETED" && (
              <>
                <SimpleButton onClick={this.handleAddRow}>Tambah</SimpleButton>

                {/* Tombol Simpan (tanpa edit mode) */}
                <SimpleButton primary onClick={this.props.handleSubmit}>
                  Simpan
                </SimpleButton>
              </>
            )}

          {this.props.tab === "with_qr" &&
            this.props.selectedData.stockOpnameStatus !== "COMPLETED" && (
              <SimpleButton onClick={this.props.handleSubmit}>
                {this.props.edit ? "Edit" : "Simpan"}
              </SimpleButton>
            )}
        </FlexView>
      </>
    );
  }
}

export default KelebihanSODetail;
